import DateUtil from "./../../utils/Date";

export function getCols() {
  return [{
    width: "20%",
    type: "string",
    label: "Address"
  }, {
    width: "20%",
    type: "string",
    label: "Date"
  }, {
    width: "20%",
    type: "string",
    label: "Ignition"
  }, {
    width: "20%",
    type: "string",
    label: "Speed"
  }, {
    width: "20%",
    type: "string",
    label: "Coordinate"
  }];
}

export function getRows(docs, t) {
  const rows = [];
  docs.map(item => {
    return rows.push([{
      id: item.id,
      value: item.gps.address
    }, {
      value: DateUtil.to({ date: new Date(item.gps.date), format: "DD/MM/YYYY HH:mm:ss", tz: "America/Sao_Paulo"})
    }, {
      value: item.tracker.ignition ? t("IgnitionOn") : t("IgnitionOff")
    }, {
      value: `${item.gps.speed} Km/h`
    }, {
      value: `${item.gps.coordinate.latitude} | ${item.gps.coordinate.longitude}`
    }]);
  });
  return rows;
}
